import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexColumn, Table } from "@opensea/ui-kit";
import { CancelOrderTableRow } from "../CancelOrderTableRow/CancelOrderTableRow";
import { CancelOrderTableFragment } from "./CancelOrderTable.fragment";
import { CancelOrderTableHeader } from "./CancelOrderTableHeader";
export const CancelOrderTable = t0 => {
  const $ = _c(11);
  const {
    orders: orderKeys,
    filteredOrderIds,
    view
  } = t0;
  let t1;
  if ($[0] !== filteredOrderIds || $[1] !== orderKeys) {
    const orders = orderKeys.map(_temp);
    t1 = filteredOrderIds ? orders.filter(order => filteredOrderIds.includes(order.id)) : orders;
    $[0] = filteredOrderIds;
    $[1] = orderKeys;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filteredOrders = t1;
  let t2;
  if ($[3] !== view) {
    t2 = {
      view
    };
    $[3] = view;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== filteredOrders) {
    t3 = <CancelOrderTableHeader orders={filteredOrders} />;
    $[5] = filteredOrders;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== filteredOrders || $[8] !== t2 || $[9] !== t3) {
    t4 = <FlexColumn className="w-full"><Table context={t2} header={t3} itemKey={_temp2} items={filteredOrders} renderRow={CancelOrderTableRow} size="xl" /></FlexColumn>;
    $[7] = filteredOrders;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(orderKey) {
  return readFragment(CancelOrderTableFragment, orderKey);
}
function _temp2(item) {
  return item?.id;
}